import { Injectable, inject } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {HttpHeaderService} from './http-header.service';
import {Observable} from 'rxjs';
import {APP_CONFIG} from '../config/app-config.token';
import {AppConfig} from '../config/app-config.model';
import {QuestionFormData} from '../model/question-form-data';
import {TicketResponse} from '../model/ticket-response';
import {DynamicsQuestions} from '../model/dynamics-questions';
import {CapacitorHttpService} from './capacitor-http.service';

@Injectable({
  providedIn: 'root'
})
export class FormService {
  private http = inject(HttpClient);
  private capacitorHttp = inject(CapacitorHttpService);
  private httpHeaderService = inject(HttpHeaderService);
  private config = inject<AppConfig>(APP_CONFIG);

  baseurl: string;

  constructor() {
    this.baseurl = this.config.apiGatewayUrl;
  }

  getDynamicQuestions(ssin: string): Observable<DynamicsQuestions[]> {
    return this.capacitorHttp.get<DynamicsQuestions[]>(this.baseurl + `/question/${ssin}/list`, this.httpHeaderService.getHeaderOptions());
  }

  // ========== METHODS FOR EXTERNAL USERS (using /me endpoints) ==========
  // These methods are for external users (members) who can only access their own data.
  // Tyk API Gateway rewrites /members/me to /members/{jwt.preferred_username}

  /**
   * Post form request for authenticated external user.
   *
   * The Consumer now returns the support TicketResponse on HTTP 200. To stay
   * backward compatible during the staggered Consumer rollout, the old behaviour
   * (HTTP 204 with an empty body) still resolves here as a null/undefined value.
   *
   * @param data Form data
   * @returns Observable<TicketResponse | null> - the ticket response, or null when the
   *          (older) Consumer answers with 204 No Content.
   */
  postMyFormRequest(data: QuestionFormData): Observable<TicketResponse | null> {
    return this.capacitorHttp.post<TicketResponse | null>(
      this.baseurl + '/members/me/forms/myabvv-question',
      data,
      this.httpHeaderService.getHeaderOptions()
    );
  }

  /**
   * Get dynamic questions for authenticated external user
   * @returns Observable<DynamicsQuestions[]>
   */
  getMyDynamicQuestions(): Observable<DynamicsQuestions[]> {
    return this.capacitorHttp.get<DynamicsQuestions[]>(
      this.baseurl + '/question/me/list',
      this.httpHeaderService.getHeaderOptions()
    );
  }
}
